/** 从 elements 派生 layers 摘要（与 canvas_schema.extract_layers 对齐） */
export function extractLayers(elements) {
  const layers = { freehand: [], shapes: [], frames: [] };
  for (const el of elements || []) {
    if (!el || !el.type) continue;
    if (el.type === 'freedraw') layers.freehand.push(el);
    else if (
      el.type === 'rectangle' ||
      el.type === 'ellipse' ||
      el.type === 'arrow' ||
      el.type === 'text'
    ) {
      layers.shapes.push(el);
    } else if (el.type === 'frame') layers.frames.push(el);
  }
  return layers;
}

/**
 * 旧版固定类型分层顺序（仅用于迁移到数组 Z 序时的稳定排序）。
 * 绘制与命中已改为 elements[] 顺序：index 0 在底，末尾在顶。
 */
export const LEGACY_TYPE_ORDER = [
  'frame',
  'card',
  'rectangle',
  'ellipse',
  'text',
  'arrow',
  'freedraw',
];

/** @deprecated 使用 LEGACY_TYPE_ORDER；保留别名以免外部引用断裂 */
export const RENDER_ORDER = LEGACY_TYPE_ORDER;

const legacyTypeIndex = new Map(LEGACY_TYPE_ORDER.map((t, i) => [t, i]));

/** 按旧类型分层稳定排序（同类型保持相对顺序） */
export function sortElementsByLegacyTypeOrder(elements) {
  const list = Array.isArray(elements) ? elements.slice() : [];
  list.sort((a, b) => {
    const ia = legacyTypeIndex.has(a?.type) ? legacyTypeIndex.get(a.type) : 999;
    const ib = legacyTypeIndex.has(b?.type) ? legacyTypeIndex.get(b.type) : 999;
    if (ia !== ib) return ia - ib;
    return 0;
  });
  return list;
}
